import { render, staticRenderFns } from "./participants-chat.vue?vue&type=template&id=58cedec4&scoped=true"
import script from "./participants-chat.vue?vue&type=script&lang=js"
export * from "./participants-chat.vue?vue&type=script&lang=js"
import style0 from "./participants-chat.vue?vue&type=style&index=0&id=58cedec4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cedec4",
  null
  
)

export default component.exports